/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SchedulerSessionJobData } from './SchedulerSessionJobData';
import {
    SchedulerSessionJobDataFromJSON,
    SchedulerSessionJobDataFromJSONTyped,
    SchedulerSessionJobDataToJSON,
    SchedulerSessionJobDataToJSONTyped,
} from './SchedulerSessionJobData';

/**
 * 
 * @export
 * @interface SchedulerSessionOverviewData
 */
export interface SchedulerSessionOverviewData {
    /**
     * 
     * @type {string}
     * @memberof SchedulerSessionOverviewData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerSessionOverviewData
     */
    projectId?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerSessionOverviewData
     */
    projectName?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerSessionOverviewData
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerSessionOverviewData
     */
    mode?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerSessionOverviewData
     */
    precalculationInterval?: string;
    /**
     * 
     * @type {Date}
     * @memberof SchedulerSessionOverviewData
     */
    plannedFor?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SchedulerSessionOverviewData
     */
    startedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SchedulerSessionOverviewData
     */
    finishedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SchedulerSessionOverviewData
     */
    since?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SchedulerSessionOverviewData
     */
    until?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof SchedulerSessionOverviewData
     */
    hasErrors?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SchedulerSessionOverviewData
     */
    errorMessage?: string | null;
    /**
     * 
     * @type {Array<SchedulerSessionJobData>}
     * @memberof SchedulerSessionOverviewData
     */
    jobs?: Array<SchedulerSessionJobData>;
}

/**
 * Check if a given object implements the SchedulerSessionOverviewData interface.
 */
export function instanceOfSchedulerSessionOverviewData(value: object): value is SchedulerSessionOverviewData {
    return true;
}

export function SchedulerSessionOverviewDataFromJSON(json: any): SchedulerSessionOverviewData {
    return SchedulerSessionOverviewDataFromJSONTyped(json, false);
}

export function SchedulerSessionOverviewDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SchedulerSessionOverviewData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
        'projectName': json['projectName'] == null ? undefined : json['projectName'],
        'status': json['status'] == null ? undefined : json['status'],
        'mode': json['mode'] == null ? undefined : json['mode'],
        'precalculationInterval': json['precalculationInterval'] == null ? undefined : json['precalculationInterval'],
        'plannedFor': json['plannedFor'] == null ? undefined : (new Date(json['plannedFor'])),
        'startedAt': json['startedAt'] === undefined ? undefined : json['startedAt'] === null ? null : (new Date(json['startedAt'])),
        'finishedAt': json['finishedAt'] === undefined ? undefined : json['finishedAt'] === null ? null : (new Date(json['finishedAt'])),
        'since': json['since'] === undefined ? undefined : json['since'] === null ? null : (new Date(json['since'])),
        'until': json['until'] === undefined ? undefined : json['until'] === null ? null : (new Date(json['until'])),
        'hasErrors': json['hasErrors'] == null ? undefined : json['hasErrors'],
        'errorMessage': json['errorMessage'] === undefined ? undefined : json['errorMessage'] === null ? null : json['errorMessage'],
        'jobs': json['jobs'] == null ? undefined : ((json['jobs'] as Array<any>).map(SchedulerSessionJobDataFromJSON)),
    };
}

export function SchedulerSessionOverviewDataToJSON(json: any): SchedulerSessionOverviewData {
    return SchedulerSessionOverviewDataToJSONTyped(json, false);
}

export function SchedulerSessionOverviewDataToJSONTyped(value?: SchedulerSessionOverviewData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'projectId': value['projectId'],
        'projectName': value['projectName'],
        'status': value['status'],
        'mode': value['mode'],
        'precalculationInterval': value['precalculationInterval'],
        'plannedFor': value['plannedFor'] == null ? value['plannedFor'] : value['plannedFor'].toISOString(),
        'startedAt': value['startedAt'] == null ? value['startedAt'] : value['startedAt'].toISOString(),
        'finishedAt': value['finishedAt'] == null ? value['finishedAt'] : value['finishedAt'].toISOString(),
        'since': value['since'] == null ? value['since'] : value['since'].toISOString().substring(0,10),
        'until': value['until'] == null ? value['until'] : value['until'].toISOString().substring(0,10),
        'hasErrors': value['hasErrors'],
        'errorMessage': value['errorMessage'],
        'jobs': value['jobs'] == null ? undefined : ((value['jobs'] as Array<any>).map(SchedulerSessionJobDataToJSON)),
    };
}

